/**
 * AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
 *
 * Generated by: scripts/generateRipConfig.ts
 * Source: RIP service instance data for 'hammerstone', 'hammerstone/hammerstone-react-ui',
 *         and 'hammerstone/hammerstone-api'
 * Generated at: 2026-11-04T11:21:01.168Z
 *
 * To regenerate: npm run generate-rip-config
 *
 * This file is committed to the repo as a working fallback for local development.
 * It is regenerated on every CI build (via `npm run release`) to stay in sync with
 * the latest RIP data. If the generation script fails, this committed version is used.
 */

/**
 * All RIP-sourced Hammerstone config, keyed by region name (e.g. 'us-east-1').
 *
 * Each entry holds:
 *   - reactUiDomain:  the react-ui (new UI) prod hostname for the region. config.ts matches this
 *                     against window.location.hostname to resolve prod config by region.
 *   - oldHammerstone: HSOLD + Permissions Tool endpoints, from the 'hammerstone' service
 *                     (default endpoint + customProperties.permissions_tool_endpoint).
 *   - hsApi:          OPTIONAL HSAPI client config, from 'hammerstone/hammerstone-api' plus the
 *                     react-ui prod account. Absent when RIP lacks the react-ui account for the
 *                     region (e.g. ZHY), in which case HSAPI is unavailable for that region.
 *
 * Non-prod stages (beta/gamma/devDesktop) are handled by a hardcoded stage fallback in config.ts.
 */
export const RIP_REGION_CONFIG: {
	[region: string]: {
		reactUiDomain: string;
		oldHammerstone: {
			hsEndpoint: string;
			ptEndpoint: string;
		};
		hsApi?: {
			endpoint: string;
			iamRolePartition: string;
			iamRoleAccount: string;
		};
	};
} = {
	'us-iso-east-1': {
		reactUiDomain: 'us-iso-east-1.prod.hammerstone.data-tools.c2s-a2z.ic.gov',
		oldHammerstone: {
			hsEndpoint: 'https://hammerstone-prime-prod.us-iso-east-1.c2s.ic.gov',
			ptEndpoint: 'https://hammerstone-permissions-prime-prod.us-iso-east-1.c2s.ic.gov',
		},
		hsApi: {
			endpoint: 'https://us-iso-east-1.api.data-tools.c2s-a2z.ic.gov',
			iamRolePartition: 'aws-iso',
			iamRoleAccount: '217866351171',
		},
	},
	'us-east-1': {
		reactUiDomain: 'hammerstone.us-east-1.data-tools.aws.a2z.com',
		oldHammerstone: {
			hsEndpoint: 'https://hammerstone.amazon.com',
			ptEndpoint: 'https://hammerstone-permissions-iad.iad.proxy.amazon.com',
		},
		hsApi: {
			endpoint: 'https://us-east-1.api.data-tools.aws.a2z.com',
			iamRolePartition: 'aws',
			iamRoleAccount: '057244456334',
		},
	},
	'us-isob-east-1': {
		reactUiDomain: 'us-isob-east-1.prod.hammerstone.data-tools.sc2s-a2z.sgov.gov',
		oldHammerstone: {
			hsEndpoint: 'https://hammerstone-prime-prod.us-isob-east-1.sc2s.sgov.gov',
			ptEndpoint: 'https://hammerstone-permissions-prime-prod.us-isob-east-1.sc2s.sgov.gov',
		},
		hsApi: {
			endpoint: 'https://us-isob-east-1.api.data-tools.sc2s-a2z.sgov.gov',
			iamRolePartition: 'aws-iso-b',
			iamRoleAccount: '750636064803',
		},
	},
	'us-west-2': {
		reactUiDomain: 'us-west-2.prod.hammerstone.data-tools.aws.a2z.com',
		oldHammerstone: {
			hsEndpoint: 'https://hammerstone-pdx.pdx.proxy.amazon.com',
			ptEndpoint: 'https://hammerstone-permissions-pdx.pdx.proxy.amazon.com',
		},
		hsApi: {
			endpoint: 'https://prod.pdx.hammerstone.api.data-tools.aws.a2z.com',
			iamRolePartition: 'aws',
			iamRoleAccount: '431997621865',
		},
	},
	'eusc-de-east-1': {
		reactUiDomain: 'hammerstone.eusc-de-east-1.data-tools.a2z.eu',
		oldHammerstone: {
			hsEndpoint: 'https://hammerstone.eusc-de-east-1.amazonaws.eu',
			ptEndpoint: 'https://hammerstone-permissions.thf.amazon.com',
		},
		hsApi: {
			endpoint: 'https://prod.eusc-de-east-1.api.data-tools.a2z.eu',
			iamRolePartition: 'aws-eusc',
			iamRoleAccount: '553942257583',
		},
	},
	'cn-northwest-1': {
		reactUiDomain: 'cn-northwest-1.prod.hammerstone.data-tools.aws.a2z.org.cn',
		oldHammerstone: {
			hsEndpoint: 'https://hammerstone.zhy.aws-border.cn',
			ptEndpoint: 'https://hammerstone-permissions.zhy.aws-border.cn',
		},
		hsApi: {
			endpoint: 'https://prod.zhy.hammerstone.api.data-tools.aws.a2z.org.cn',
			iamRolePartition: 'aws-cn',
			iamRoleAccount: '352491129396',
		},
	},
};
